import { getRandomInt } from '../utils';

export default function (server) {
  server.loadFixtures();

  // The goal of default schema is to test a wide range of cases with randomized data and fixed data
  // To be used in a general dev environment

  const fixturePurchasers = server.schema.purchasers.all().models;
  const generatedPurchasers = server.createList('purchaser', 3);

  // Combining factories and fixtures
  const purchasers = [...fixturePurchasers, ...generatedPurchasers];

  // purchasers are manually assigned to the user
  const currentUser = server.schema.users.first();
  currentUser.update('purchasers', purchasers);

  // Assigning factories to fixture district
  generatedPurchasers[0].update('district', '10010');
  generatedPurchasers[1].update('district', '10010');

  // Assigning factory teachers
  for (let i = 0; i < 10; i++) {
    server.create('teacher', {
      linkedPurchaserId: generatedPurchasers[0].id,
      linkedPurchaserName: generatedPurchasers[0].name,
    });
    server.create('teacher', {
      linkedPurchaserId: generatedPurchasers[1].id,
      linkedPurchaserName: generatedPurchasers[1].name,
    });
  }

  for (let i = 0; i < 20; i++) {
    server.create('teacher', {
      linkedPurchaserName: generatedPurchasers[2].name,
      linkedPurchaserId: generatedPurchasers[2].id,
    });
  }

  // find all teachers that are assigned to the generated purchaser #2
  const teachers = server.schema.teachers.where({
    linkedPurchaserId: generatedPurchasers[2].id,
  }).models;

  // generate courses for each teacher
  teachers.forEach((teacher) => {
    server.createList('course', getRandomInt(1, 20), {
      teacher,
    });
  });

  // dynamically generate some students for our dynamic school
  server.createList('student', 20, {
    linkedPurchaserId: generatedPurchasers[2].id,
  });

  // dynamically generate some admins for our dynamic school
  server.createList('user', 8, {
    managedPurchasers: [generatedPurchasers[2]],
  });

  // dynamically generate an auditor for our dynamic school
  server.create('auditor', {
    purchaser: generatedPurchasers[2],
  });

  // ensure the current user (Magnus) is added to this generated school
  currentUser.update('managedPurchasers', [
    ...currentUser.managedPurchasers.models,
    generatedPurchasers[2],
  ]);

  console.log(server.schema);
}
